import styles from "./Loading.module.css";

const Loading = () => (
  <div className={styles.loading}>
    <div className={styles.spinner}></div>
    <p>Đang tải...</p>
  </div>
);

export default Loading;